import CryptoAES from 'crypto-js/aes';

const key = process.env.REACT_APP_DECRYPT_KEY;
const DecryptHelper = {
  encryptWithKey: data => {
    return fnEncryptData(data);
  }
};

export default DecryptHelper;
function fnEncryptData(data) {
  try {
    const ciphertext = CryptoAES.encrypt(JSON.stringify(data), key);
    return ciphertext.toString().replaceAll('+', 'p1L2u3S');
  } catch (err) {
    return '';
  }
}
